/**
 * "UniGate · platform ✓" / "Website key · missing" chips for a MagTek online processor.
 * Super Admin only (names the processor). A missing chip links to Payment processors.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { type MagtekReadiness, readinessText, PAYMENT_PROCESSORS_PATH } from './unigateCreds';

const Chip: React.FC<{ label: string; value: 'location' | 'platform' | null; testId: string }> = ({ label, value, testId }) => {
  const ok = !!value;
  const cls = `inline-flex min-h-[24px] items-center gap-1 rounded-full px-2.5 text-[11px] font-semibold ${ok ? 'bg-emerald-50 text-emerald-700' : 'bg-[#FFF1F3] text-ruby-deep'}`;
  const body = <>{label} · {readinessText(value)}{ok && <Check size={11} />}</>;
  return ok
    ? <span data-testid={testId} className={cls}>{body}</span>
    : <Link to={PAYMENT_PROCESSORS_PATH} data-testid={testId} className={`${cls} hover:underline`}>{body}</Link>;
};

export const MagtekReadinessChips: React.FC<{ readiness: MagtekReadiness | null | undefined }> = ({ readiness }) => (
  <span className="inline-flex flex-wrap items-center gap-1.5" data-testid="mt-readiness">
    <Chip label="UniGate" value={readiness?.unigate ?? null} testId="mt-chip-unigate" />
    <Chip label="Website key" value={readiness?.teconnect ?? null} testId="mt-chip-te" />
  </span>
);
